import { Box, Button, Typography } from '@mui/joy';
import { useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import TextFieldElement from '../TextFieldElement';

interface Props {
  defaultValues: any;
  title: string;
  name: string;
  label: string;
  caption?: string;
  placeholder?: string;
  rules?: any;
  onSubmit?: any;
  saving?: boolean;
  onCancel?: () => void;
}

function EditNumberInner({
  defaultValues,
  onSubmit,
  name,
  label,
  caption,
  placeholder,
  rules,
  saving,
  onCancel,
  title,
}: Props) {
  const { handleSubmit, control } = useForm<any>({
    defaultValues,
  });

  const onValidSubmit: SubmitHandler<any> = useCallback(
    (values: any) => onSubmit({ ...values, [name]: Number(values[name]) }),
    [onSubmit, name],
  );

  return (
    <form onSubmit={handleSubmit(onValidSubmit)}>
      <Typography level="h3" sx={{ mb: 2, textAlign: 'center' }}>
        {title}
      </Typography>
      <TextFieldElement
        control={control}
        name={name}
        label={label}
        caption={caption}
        rules={rules}
        placeholder={placeholder}
        type="number"
        step="any"
      />
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
        <Button
          variant="outlined"
          color="neutral"
          size="lg"
          onClick={onCancel}
          sx={{ mr: 4, width: 100 }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          loading={saving}
          variant="solid"
          size="lg"
          sx={{ width: 100 }}
        >
          Save
        </Button>
      </Box>
    </form>
  );
}

export default EditNumberInner;
